require.ensure(["./b"], function(require) {
	require("./b").should.be.eql("a");
})


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/chunk-callback-order/duplicate2.js
 ** module id = 2
 ** module chunks = 1
 **/